module.exports = __webpack_public_path__ + "static/img/otp_pic.27621c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_pop_up/otp_pic.png
// module id = fQPR
// module chunks = 1